export const COVER_SLIDE_TITLE_SUGGESTIONS = [
  'Estate planning analysis for {Household name}, {Current date}',
  'Client review for {Household name}, {Current date}',
  '{Household name} estate plan, {Current date}',
];
